import { mapActions, mapState } from 'vuex'

import funcoes from '../../util/funcoes.js';

import { BANCOS_HOMOLOGADOS } from '../../util/constantes';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUniversity } from '@fortawesome/free-solid-svg-icons';

library.add(faUniversity)

export default {
  components: {
    FontAwesomeIcon
  },

  data() {
    return {
      arquivoRetorno: {
        nomeArquivo: undefined,
        banco: undefined
      },

      historicoRetorno: {
        pagina: 0,
        dataProcessamentoInicio: funcoes.primeiroDiaMes(),
        dataProcessamentoFim: funcoes.ultimoDiaMes(),
        nomeBanco: undefined
      },

      tabSelecionada: 'lancamentos',

      isLoadingImportar: false
    }
  },

  computed: {
    ...mapState('retornoBancarioFinanceiroStore',{
      recibosRetorno(state) { return state.recibosRetorno },
      historicoRetornos(state) { return state.historicoRetornos }
    }),

    bancos() {
      return BANCOS_HOMOLOGADOS;
    },

    classFieldIsActiveArquivo() {
      return this.tabSelecionada == 'lancamentos' ? 'field-is-active' : ''
    },

    classFieldIsActiveHistorico() {
      return this.tabSelecionada == 'historicoBaixas' ? 'field-is-active' : ''
    },
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('retornoBancarioFinanceiroStore', [
      'processarRetorno',
      'listarHistoricoRetorno',
      'limparRecibosRetorno'
    ]),

    selecionarArquivoHandler() {
      this.limparRecibosRetorno();

      if(this.$refs.upload.uploadFiles.lenght === 1) {
        this.$refs.upload.clearFiles();
      }
    },

    processarRetornoHandler() {
      this.isLoadingImportar = true;
      this.arquivoRetorno.nomeArquivo = this.$refs.upload.uploadFiles[0].name
      this.arquivoRetorno.arquivo = this.$refs.upload.uploadFiles[0].raw

      let payload = new FormData();
      payload.append("arquivo", this.$refs.upload.uploadFiles[0].raw);
      payload.append("nomeArquivo", this.$refs.upload.uploadFiles[0].name);
      payload.append("banco", this.arquivoRetorno.banco);

      this.processarRetorno(payload)
        .then((resultado) => {
          this.hideLoading();
          this.limparCampos();
          switch (resultado.status) {
            case "FALHA":
              this.$message.warning(resultado.mensagem);
              this.isLoadingImportar = false
              break;
            case "SUCESSO":
              window.open(resultado.mensagem, '_blank');
              this.isLoadingImportar = false
          }
        })
        .catch(() => {
          this.hideLoading()
          this.limparCampos();
          this.$message.error("Não foi possível conectar-se ao servidor");
          this.isLoadingImportar = false;
        });
    },

    historicoRetornoHandler() {
      this.showLoading();

      this.listarHistoricoRetorno(this.historicoRetorno)
        .then(() => {
          this.hideLoading()
          this.limparCampos();
        })
        .catch(() => {
          this.hideLoading()
          this.limparCampos();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    getLabelBanco(item) {
      return funcoes.getLabel(this.bancos,item.nomeBanco)
    },
    getPlanoConta(item) {
      if(!item.lancamento) return ''
      return item.lancamento ? item.lancamento.conta.contaPlanoConta.nome : '';
    },
    getNome(item) {
      if(!item.lancamento) return ''
      return item.lancamento ? item.lancamento.conta.cliente.nome : '';
    },
    getDataVencimento(item) {
      if(!item.lancamento) return ''
      return item.lancamento ? item.lancamento.dataVencimento : '';
    },
    getValor(item) {
      if(!item.lancamento) return ''
      return item.lancamento ? funcoes.formatarValor(item.lancamento.valor) : ''; 
    },

    limparCampos() {
      this.arquivoRetorno = {
        nomeArquivo: undefined,
        banco: undefined
      }
    },

    formatarValor(item) {
      return funcoes.formatarValor(item)
    },

    changeDetailsTableRow(arquivoRetorno) {
        return arquivoRetorno.lancamento == null
    },

    stateRowTable(arquivoRetorno) {
        let stateRow = { titleIcon: '',title: '', colorIcon: '' }

        if(arquivoRetorno.tipo == 'ERRO') {
            stateRow = { titleIcon: 'el-icon-error', title: 'Erro ao processar', colorIcon: '#DF1B1B' }
            return stateRow
        } else if(arquivoRetorno.lancamento == null && ((arquivoRetorno.recibo && arquivoRetorno.recibo.id > 0) || (arquivoRetorno.boletoAvulso && arquivoRetorno.boletoAvulso.id > 0))) {
            stateRow = { titleIcon: 'el-icon-document-delete', title: 'Recibo/BoletoAvulso de Aluguel', colorIcon: '#FF9E29' }
            return stateRow;
        } else if(arquivoRetorno.lancamento == null) {
            stateRow = { titleIcon: 'el-icon-document-delete', title: 'Lançamento não encontrado', colorIcon: '#DF1B1B'  }
            return stateRow;
        } else if(arquivoRetorno.lancamento && arquivoRetorno.lancamento.id > 0) {
            if(arquivoRetorno.tipo == 'REGISTRO' && arquivoRetorno.mensagemResultado.includes('Registrado Previamente')) {
                stateRow = { titleIcon: 'el-icon-document-checked', title: 'Recibo registrado previamente', colorIcon: '#FF9E29' }
                return stateRow
            } else if(arquivoRetorno.tipo == 'REGISTRO' && arquivoRetorno.mensagemResultado.includes('Registrado com sucesso')) {
                stateRow = { titleIcon: 'el-icon-document-checked', title: 'Recibo registrado com sucesso', colorIcon: '#2DB748' }
                return stateRow
            } else if(arquivoRetorno.tipo == 'PAGO' && arquivoRetorno.mensagemResultado.includes('efetuado previamente')) {
                stateRow = { titleIcon: 'el-icon-success', title: 'Recibo pago previamente', colorIcon: '#FF9E29' }
                return stateRow
            } else if(arquivoRetorno.tipo == 'PAGO' && arquivoRetorno.mensagemResultado.includes('efetuado com sucesso')) {
                stateRow = { titleIcon: 'el-icon-success', title: 'Recibo pago com sucesso', colorIcon: '#2DB748' }
                return stateRow
            } else if(arquivoRetorno.tipo == 'PAGO' && arquivoRetorno.mensagemResultado.includes('Inconsistência')) {
                stateRow = { titleIcon: 'el-icon-error', title: 'Inconsistência no valor de pagamento', colorIcon: '#DF1B1B' }
                return stateRow
            }
        } else {
            return stateRow;
        }
    },

    messageRow(arquivoRetorno) {
        if(arquivoRetorno.mensagemResultado.includes('Pagamento efetuado com boletos anteriores em aberto') && !arquivoRetorno.mensagemResultado.includes('Inconsistência')) {
            return 'Pagamento efetuado com boletos anteriores em aberto.'
        } else if(arquivoRetorno.tipo == 'ERRO') {
            return arquivoRetorno.mensagemResultado
        } else {
            return '';
        }
    }
  },
}